import React, { useEffect, useState } from 'react';
import { PolicyModel, RiderStatusType } from '../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareMinus, faSquarePlus } from '@fortawesome/free-regular-svg-icons';
import { faHammer } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, MenuProps, Tooltip } from 'antd';
import ClientPolicyDetails from './PolicyDetails/_ClientPolicyDetails';
import { IDNameDescriptionDictionary } from '../models/Site';
import { set } from 'date-fns';
import { GeneralDataModel } from '../models/GeneralDataModel';
import UploadDocumentPopUp from './documents/_UploadDocumentPopUp';
import MessegePopup from '../subscribers/popups/_MessegePopup';
import { OfferProductionModel } from '../models/OfferProductionModel';
import { setCreateTreatmentFrom } from '../app-context/tasksSlice';
import { useDispatch } from 'react-redux';
import { setNewPolicyWithAdditionNumber } from '../app-context/clientsSlice';

type Props = {
    isSelected?: boolean;
    policyDetails: any;
    config: any;
    showAddTreatmentPopup?: (type: number) => void;
    displayFile?: (file: any) => void;
    customerData: any;
};


enum policyDateStatus {
    _ACTIVE = 'green',
    _FREEZED = 'LightGray',
    _INVALID = 'LightGray', //_NOTYETACTIVE
    _EXPIRED = 'LightGray',
    _RENEW = 'blue',
    _CANCELED = 'red',
    _FUTURE = 'orange'
}

const ClientPolicy = (props: Props) => {
    const dispatch = useDispatch();
    const [policyItemItem, setPolicyitem] = useState<any>(props.policyDetails);
    const [policyNumber, setPolicyNumber] = useState<string>(props.policyDetails.policyNumber)
    const [policyIndex, setPolicyIndex] = useState<number>(0)
    const [apiUrl, setApiUrl] = useState<string>('');
    const [clientItems, setClientItems] = useState<MenuProps['items']>([]);
    const [policyStatusStyle, setPolicyStatusStyle] = useState<any>({ color: 'green' });
    const [policyStatusColor, setPolicyStatusColor] = useState<string>('green');
    const [assetTitle, setAssetTitle] = useState<string>('');
    const [assetSubTitle, setAssetSubTitle] = useState<string>('');
    const [assetDescription, setAssetDescription] = useState<string>('');
    const [premia, setPremia] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns)
    const [policyTypes, setPolicyTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    const [showModelUploadDocument, setShowModelUploadDocument] = useState<{ show: boolean, customerId: string }>({ show: false, customerId: props.policyDetails.customerId });
    const [hasNewDocument, setHasNewDocument] = useState<boolean>(false);
    const [showPopUpMessage, setShowPopUpMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');

    const [policyStatuses, setPolicyStatuses] = useState<any[]>([]);

    const prepareLicenseNumber = (licenceNumber: string) => {
        const chunks: string[] = [];
        // console.log('prepareLicenseNumber', licenceNumber);
        chunks.push(licenceNumber.substring(0, 3));
        // console.log('prepareLicenseNumber', licenceNumber.substring(0, 3))
        chunks.push(licenceNumber.substring(3, 5));
        // console.log('prepareLicenseNumber', licenceNumber.substring(3, 5))
        chunks.push(licenceNumber.substring(5, 8));
        // console.log('prepareLicenseNumber', licenceNumber.substring(5, 8))
        // console.log('prepareLicenseNumber', chunks.join('-'));
        return chunks.join('-');
    }

    const onIconClick = () => {
        //console.log('onIconClick')
        if (props.config.onIconClick) {
            props.config.onIconClick()
            //console.log('onIconClick')
        }
    }

    const onArrowClick = () => {
        const currStatus = isOpen;
        setIsOpen(!currStatus);
    }

    const onRowClick = (e: any) => {
        // if (e.target.parentElement.className.indexOf('cell') >= 0) {
        //     if (e.target.className =='act-btn-icon icon menu-hamburger pointer' || 
        //         e.target.className == 'action-btn-menu-item pointer' || 
        //         e.target.className == 'ant-select-selection-item' || 
        //         e.target.className == 'ant-select-item-option-content' ||
        //         e.target.className == 'icon paperclip pointer'||
        //         e.target.className == 'description bold cell-value phone-number' ||
        //         e.target.parentElement.className == 'cell car-details' ||
        //         e.target.parentElement.className.indexOf('on-click-ignore') > 0
        //     ) return;
        //     try {

        //     } catch (error) {
        //         // return;
        //     }

        //     console.log('onRowClick', e, e.target.className);
        // }
        // ant-dropdown-menu
        if (e.target.className.indexOf('menu-hamburger') > -1 ||
            e.target.className.indexOf('ant-dropdown-menu') > -1 ||
            e.target.parentElement.className.indexOf('ant-dropdown-menu-title-content') > -1 ||
            e.target.parentElement.className.indexOf('on-click-ignore') > -1
        ) {
            return
        } else {
            onArrowClick();
        };
    }


    const onMenuClicked = async (action: string) => {
        switch (action) {
            case 'open':
                console.log('open');
                if (props.config.onSelectPolicy) {
                    props.config.onSelectPolicy(policyNumber);
                }
                break;
            case 'claimCreate': {
                console.log('onClaimCreate SueDetails', policyItemItem);
                if (props.config.onClaimCreate) {
                    props.config.onClaimCreate(policyNumber, policyItemItem);
                }
                break;
            }
            case 'fileUpload': {
                console.log('fileUpload');
                setShowModelUploadDocument({ show: true, customerId: policyItemItem.customerId });
                break;
            }
            case 'task': {
                console.log('onCreateTask SueDetails', policyItemItem);
                if (props.showAddTreatmentPopup) {
                    dispatch(setCreateTreatmentFrom({ type: 'policy', id: policyItemItem.id }));
                    props.showAddTreatmentPopup(1);
                }
                break;
            }
            case 'additonalNumber': {
                console.log('additonalNumber');
                dispatch(setNewPolicyWithAdditionNumber({ policyId: policyItemItem.id, additionNumber: Number(policyItemItem.additionNumber) + 1 + '' }));
                break;
            }
            default:
                emptyFunc();
                break;
        }
    }

    const onClick: MenuProps['onClick'] = ({ key }) => {
        // message.info(`Click on item ${key}`);
    };

    const buildDropDownMenu = () => {
        setClientItems([
            {
                key: '1',
                label: (
                    <div className="pointer rtl"
                        onClick={() => { onArrowClick() }}
                    >
                        פתח
                    </div>
                ),
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('delete') }}
                    >
                        שלח אל
                    </div>,
                key: '2',
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('task') }}
                    >
                        יצירת משימה
                    </div>,
                key: '3',
            },
            // {
            //     label:
            //         <div className="pointer rtl"
            //             onClick={() => { onMenuClicked('additonalNumber') }}
            //         >
            //             יצירת תוספת
            //         </div>,
            //     key: '7',
            // },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('claimCreate') }}
                    >
                        הקם תביעה
                    </div>,
                key: '4',
            },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('fileUpload') }}
                    >
                        העלאת קובץ
                    </div>,
                key: '5',
            },
            // {
            //     label:
            //         <div className="pointer rtl"
            //             onClick={() => { onMenuClicked('delete') }}
            //         >
            //             סריקת מסמך
            //         </div>,
            //     key: '6',
            // },
            {
                label:
                    <div className="pointer rtl"
                        onClick={() => { onMenuClicked('delete') }}
                    >
                        מחק
                    </div>,
                key: '8',
            }
        ]);
    }

    useEffect(() => {
        const aUrl = localStorage.getItem('apiFilesUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        // setPolicyIndex
        if (props.config.index) {
            setPolicyIndex(props.config.index);
        }
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
    }, [props])

    useEffect(() => {
        const fetchData = async () => {

            let policyTypes = await new GeneralDataModel().getAppDictionaryListExpanded();
            setPolicyTypes(policyTypes);

            const storedPolicyStatuses = localStorage.getItem('policyStatuses');
            if (storedPolicyStatuses) {
                const policyStatusesData = JSON.parse(storedPolicyStatuses);
                setPolicyStatuses(policyStatusesData.map((ps: any)=>{ 
                    return {
                        label: ps.name,
                        value: ps.id.toString()
                    }
                }))
                return;
            }

            const policyStatusesData = await new OfferProductionModel().getPolicyStatuses();
            setPolicyStatuses(policyStatusesData.map((ps: any)=>{ 
                return {
                    label: ps.name,
                    value: ps.id.toString()
                }
            }))
            localStorage.setItem('policyStatuses', JSON.stringify(policyStatusesData));

        }
        fetchData();
        // console.log('policy init', props.policyDetails);

        const policyItem = props.policyDetails;
        if (policyItem.vehicle) {
            setAssetTitle(policyItem.vehicle.licenseNumber)
            // setAssetTitle(prepareLicenseNumber(policyItem.vehicle.licenseNumber))

        }
        // setPremia
        // if (policyItem.riderPackages && policyItem.riderPackages.length > 0) {
        //     let totalCustomerCost: number = 0;
        //     policyItem.riderPackages.forEach((p: any)=> {
        //         totalCustomerCost += p.customerCost
        //     })
        //     setPremia(totalCustomerCost);
        // }
        if (policyItem.policyAdditionDetails && policyItem.policyAdditionDetails.premiumSum) {
            setPremia(policyItem.policyAdditionDetails.premiumSum);
        }
        buildDropDownMenu();
        const today = moment();
        const statusId = policyItem && policyItem.policyAdditionDetails && policyItem.policyAdditionDetails.elementaryPolicyStatusId ? policyItem.policyAdditionDetails.elementaryPolicyStatusId.toLowerCase() : "";


        if (policyItem.policyAdditionDetails && (policyItem.policyAdditionDetails.eventType == 4 || policyItem.policyAdditionDetails.elementaryPolicyStatusId == "cc68852c-e281-40bd-94a9-f17bb8527420" || policyItem.policyAdditionDetails.elementaryPolicyStatusId == "8928E341-E000-4D25-B2BC-440ED1E98CE4")) {
            setPolicyStatusStyle({ color: policyDateStatus._CANCELED });
            setPolicyStatusColor(policyDateStatus._CANCELED);
        } else if (moment(policyItem.endDate).isBefore(today)) {
            setPolicyStatusStyle({ color: policyDateStatus._INVALID });
            setPolicyStatusColor('grey');
        } else if (moment(policyItem.endDate).month() == today.month() && moment(policyItem.endDate).year() == today.year()) {
            setPolicyStatusStyle({color: policyDateStatus._RENEW});
            setPolicyStatusColor(policyDateStatus._RENEW);
        }
        else if (
            statusId &&
            [
                "9e25b1bd-6e92-4b86-83c1-3bcbc6c0e6ed",
                "4c5b49e1-f9d5-43b9-8783-52187e6471f7",
                "5b0d87ff-863b-4eb9-8476-62c5e5609654",
                "2f2e01cd-f5c3-4347-90b3-bca2eaf2c057",
                "d6cc572a-93d6-43df-b22e-f1ed6400bd43",
            ].includes(statusId)
        ) {
            setPolicyStatusStyle({ color: policyDateStatus._FUTURE });
            setPolicyStatusColor(policyDateStatus._FUTURE);
        }
        else {
            setPolicyStatusStyle({ color: policyDateStatus._ACTIVE });
            setPolicyStatusColor(policyDateStatus._ACTIVE);
        }
    }, [])

    const emptyFunc = () => { }


    const getIcon = (policyItemItem: any) => {
        if (policyItemItem.policyType) {
            let policyType = policyItemItem.policyType
            switch (policyType.policyTypeId) {
                case 1: // רכב 
                    return 'vehicle';
                case 2: // בית
                    return 'house';
                case 3: // עסק
                    return 'buisness';
                case 4: // ביטוח חיים
                    return 'life';
                case 5: // בריאות
                    return 'health';
                case 6: // עסקי
                    return 'proffessional';

                case 9: // ביטוח סוג רכב אחר
                    return 'vehicle';
                case 12: // ימי או אוויר
                    return 'marine';
                default:
                    return 'other'; // ברירת מחדל לרכב פרטי
            }
        }
    }

    return (
        <div className={`policy-details data-card-row ${isOpen ? 'opened' : ''}`}>

            {
                showPopUpMessage &&
                <MessegePopup
                    message={message}
                    statusMessege='success'
                    show={showPopUpMessage}
                    onClose={() => setShowPopUpMessage(false)}

                />
            }

            {
                showModelUploadDocument.show &&
                <UploadDocumentPopUp
                    onClose={() => {
                        setShowModelUploadDocument({ show: false, customerId: '' })
                        if (hasNewDocument) {
                            setMessage('מסמך נוסף בהצלחה')
                            setShowPopUpMessage(true);
                            setHasNewDocument(false);
                        }
                    }}
                    policyItem={props.policyDetails}
                    config={{ customerId: showModelUploadDocument.customerId, relationId: policyItemItem.id }}
                    fromPolicy={"1"}
                    relationType={2} // 2 - policy, 3 - rider
                    onSetHasNewDocument={() => setHasNewDocument(true)}
                />
            }
            <Dropdown menu={{ items: clientItems }} trigger={['contextMenu']}>
                <div className={`${props.config.showRightCell ? 'flex-space-between flex-centered' : ''}`} onClick={(e: any) => onRowClick(e)}>
                    <div className={`policy-empty-right-cell ${props.config.showRightCell ? '' : 'hide'}`}>
                        <div className={`${!props.config.parent && props.config.isFirst ? 'icon policy-right-icon' : 'hide'}`}></div>
                    </div>
                    <div className={`data-card client-details-row flex-grow policy-item flex-space-between ${props.isSelected ? 'selected-policy' : ''}`}>
                        <div className="data-card-body" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div className={`cell icon policy-icon on-click-ignore ${props.config.showRightCell ? 'hide' : ''}`}>
                                <div className={`policy-icon-holder on-click-ignore  ${props.config.parent ? '' : 'hide'}`}>
                                    {props.config.parent && props.config.open ? (
                                        <div className='icon squire-minus pointer' onClick={onIconClick}></div>
                                    ) : (<></>)}
                                    {props.config.parent && !props.config.open ? (
                                        <div className='icon squire-plus pointer' onClick={onIconClick}></div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="cell policy-type">
                                <div className="cell-value flex-centered " style={{ whiteSpace: 'initial' }}>
                                    <div className={`icon status ${policyStatusColor}`}></div>
                                    <div className={`icon policy-type ${getIcon(policyItemItem)}`}></div>
                                    {policyItemItem.policyType ? policyItemItem.policyType.name : 'ביטוח רכב'}
                                </div>
                            </div>
                            <div className="cell policy-number on-click-ignore">
                                <div className="cell-value" title={policyItemItem.riderStatusType}>
                                    {policyNumber}{policyItemItem.additionNumber==''?'':'/'+policyItemItem.additionNumber}
                                </div>
                            </div>
                            <div className="cell insurance-branch">
                                <div className="cell-value">
                                    {policyItemItem && policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.route && policyItemItem.policyAdditionDetails.vehiclePolicyType == 6 ?
                                        (<>
                                            {policyItemItem.policyAdditionDetails.route.compulsoryRouteId ? policyItemItem.policyAdditionDetails.route.compulsoryRouteId : ""}
                                        </>)
                                        : (
                                            <>
                                                {policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.route && policyItemItem.policyAdditionDetails.route.routeId ? policyItemItem.policyAdditionDetails.route.routeId : ""}
                                            </>
                                        )}
                                </div>
                            </div>
                            <div className="cell insurance-company">
                                <div className="cell-value">
                                    {policyItemItem.insuranceCompany ? policyItemItem.insuranceCompany.name : 'N/A'}
                                </div>
                            </div>
                            <div className="cell short start-date">
                                <div className="cell-value" style={policyStatusStyle}>
                                    {policyItemItem.extensionStartDate && moment(policyItemItem.extensionStartDate).format('DD-MM-YYYY') != "01-01-0001" ?
                                        moment(policyItemItem.extensionStartDate).format('DD-MM-YYYY') : moment(policyItemItem.startDate).format('DD-MM-YYYY')}
                                </div>
                            </div>
                            <div className="cell short end-date">
                                <div className="cell-value" style={policyStatusStyle}>
                                    {policyItemItem.extensionEndDate && moment(policyItemItem.extensionEndDate).format('DD-MM-YYYY') != "01-01-0001" ?
                                        moment(policyItemItem.extensionEndDate).format('DD-MM-YYYY') : moment(policyItemItem.endDate).format('DD-MM-YYYY')}
                                </div>
                            </div>
                            <div className="cell short insurance-type">
                                <div className=" cell-value insuranceType">
                                    {/* {policyItemItem.insuranceType} */}
                                    {policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.vehiclePolicyType >= 0 && policyTypes[policyItemItem.policyAdditionDetails.vehiclePolicyType]
                                        && policyTypes[policyItemItem.policyAdditionDetails.vehiclePolicyType].description ? policyTypes[policyItemItem.policyAdditionDetails.vehiclePolicyType].description : ''}
                                    {/* {policyItemItem.insuranceType ? policyItemItem.insuranceType.name : 'N/A'} */}
                                </div>
                            </div>
                            <div className="cell short vechicle-number on-click-ignore">
                                <div className='sub-title'>{assetTitle}</div>
                                <div className="cell-value">
                                    {policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.vehicle ? policyItemItem.policyAdditionDetails.vehicle.licenseNumber : ''}
                                </div>
                            </div>
                            <div className="cell short car-year">
                                <div className="cell-value">
                                    <>
                                        {policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.vehicle ? policyItemItem.policyAdditionDetails.vehicle.carYear : ''}
                                    </>
                                </div>
                            </div>
                            <div className="cell short vechicle-name">
                                <div className="cell-value" >

                                    <>
                                        {policyItemItem.policyAdditionDetails && policyItemItem.policyAdditionDetails.vehicle && policyItemItem.policyAdditionDetails.vehicle.vehicleSubModel
                                            && policyItemItem.policyAdditionDetails.vehicle.vehicleSubModel.name ? (
                                            <>
                                                <Tooltip placement="bottom" title={policyItemItem.policyAdditionDetails.vehicle.vehicleSubModel.name}>
                                                    {policyItemItem.policyAdditionDetails.vehicle.vehicleSubModel.name}
                                                </Tooltip>
                                            </>
                                        ) : ""}
                                    </>

                                </div>
                            </div>
                            <div className="cell short premium">
                                <div className="cell-value">
                                    ₪
                                    {premia}
                                </div>
                            </div>
                            {/* <div className="cell short user-name">
                                <div className="description cell-value">
                                    {policyItemItem.customer ? policyItemItem.customer.fullName : 'N/A'}
                                </div>
                            </div> */}
                            <div className="cell short hammer-icon">
                                {policyItemItem.hasSues &&
                                    <div className="cell-value pointer">
                                        <div className='icon gavel-regular'></div>
                                    </div>
                                }
                            </div>
                            <div className={`cell short program-name ${!additionalColumns || additionalColumns.seniority.hidden ? 'hide' : ''}`}>
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className={`cell short model-code ${!additionalColumns || additionalColumns.numberOfDrivers.hidden ? 'hide' : ''}`}>
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className={`cell short creation-date ${!additionalColumns || additionalColumns.regular.hidden ? 'hide' : ''}`}>
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className={`cell short creation-date ${!additionalColumns || additionalColumns.selected.hidden ? 'hide' : ''}`}>
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide approved-drivers">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide driver-ages">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide agent">
                                <div className="description cell-value">
                                    {policyItemItem.agent ? policyItemItem.agent.name : 'N/A'}
                                </div>
                            </div>
                            <div className="cell short hide road-service-provider">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide property-address">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide branch-name">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide policy-status">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide pos-stand">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide pos-stand">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide pos-balance">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide cash-register-route">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            <div className="cell short hide employer-name">
                                <div className="description cell-value">
                                    N/A
                                </div>
                            </div>
                            {/* <div className="cell short">
                                <div className="description cell-value">
                                    {policyItemItem.status}
                                </div>
                            </div>
                            <div className="cell short">
                                <div className="description cell-value">
                                    {policyItemItem.agent ? policyItemItem.agent.name : ''}
                                </div>
                            </div>
                            <div className="cell short">
                                <div className="description cell-value">
                                    {policyItemItem.user ? policyItemItem.user.name : ''}
                                </div>
                            </div>
                            <div className="cell short">
                                <div className="description cell-value">
                                    {policyItemItem.comments}
                                </div>
                            </div> */}

                            <div className="cell actions">
                                {props.config.parent ?
                                    <>
                                    </>
                                    : <></>}
                                <Dropdown menu={{ items: clientItems }}>
                                    <div className="act-btn-icon icon menu-hamburger pointer"></div>
                                </Dropdown>
                                {/* <div className='icon down-arrow pointer'onClick={onArrowClick}></div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </Dropdown>
            <div className={`${isOpen ? '' : 'hide'}`}>
                <ClientPolicyDetails data={policyItemItem} showAddTreatmentPopup={props.showAddTreatmentPopup || emptyFunc}
                    displayFile={props.displayFile ? props.displayFile : emptyFunc} customerData={props.customerData}
                />
            </div>
        </div>
    )
}

export default ClientPolicy;